import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { Pageable, CountryDTO, CountryFilterSpec, WrapperPageableResponseCountryDTO } from '../core/models';

export type { CountryDTO, CountryFilterSpec, WrapperPageableResponseCountryDTO } from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getCountries(
    spec: CountryFilterSpec = {},
    pageable: Pageable = { page: 0, size: 300 }
  ): Observable<WrapperPageableResponseCountryDTO> {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(sort => params = params.append('sort', sort));
    }
    return this.http.get<WrapperPageableResponseCountryDTO>(`${this.apiUrl}/countries`, { params });
  }
}
